import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
import { createProvider } from './vue-apollo'
import './assets/scss/material-dashboard.scss'
import 'material-icons/iconfont/material-icons.css'
import Notifications from './components/NotificationPlugin'

Vue.config.productionTip = false
Vue.use(Notifications);

new Vue({
  router,
  store,
  vuetify,
  apolloProvider: createProvider(),
  render: h => h(App)
}).$mount('#app')
